import React from 'react';

import { ConnectedQueryParamUpdateProvider } from '~src/bootstrap/routerHelpers/QueryParamUpdateProvider';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { ConnectedAllLabelsSpace } from './ConnectedAllLabelsSpace';

export interface AllLabelsSpaceProviderProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const AllLabelsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'labelValues',
  subspaceName: undefined
};

export const AllLabelsSpaceProvider: React.FunctionComponent<AllLabelsSpaceProviderProps> = ({urls, ...props}) => {
  React.useEffect(
    () => {
      getAppStore().dispatch(
        updateBreadcrumbs([getLabelsPlaceBreadcrumb(urls)])
      );
    },
    [urls]
  );

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllLabelsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={false}
        shouldUpdateSort={false}
      >
        <ConnectedAllLabelsSpace siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

function getLabelsPlaceBreadcrumb(urls: SpacesSiteUrls): BreadcrumbStateInfo {
  const href = urls.labelsUrl();
  return {
    id: href,
    text: Messages.labels(),
    href: href,
    testId: 'labels-link'
  };
}
